import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, FilePicker } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const useStyles = createUseStyles(styles, 'CopilotBarFileUpload');

const CopilotBarFileUpload = ({ files = [], isLoading = false, maxFiles, onFilesChange }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();

    const onDrop = useCallback(
        (acceptedFiles) => {
            if (acceptedFiles?.length > 0) {
                const newFiles = [...files, ...acceptedFiles].slice(0, maxFiles);
                onFilesChange(newFiles);
            }
        },
        [files, maxFiles, onFilesChange],
    );

    const onRemove = useCallback(
        (deletedFile) => {
            const newFiles = files.filter(
                (file) =>
                    !(
                        file.name === deletedFile.name &&
                        file.size === deletedFile.size &&
                        file.type === deletedFile.type
                    ),
            );
            onFilesChange(newFiles);
        },
        [files, onFilesChange],
    );

    return (
        <FilePicker
            classes={classes}
            files={files}
            isLoading={isLoading}
            maxFiles={maxFiles}
            onDrop={onDrop}
            onRemove={onRemove}
            title={t('label_copilot_drag_files_here_or_click_to_browse')}
            isFullWidth
            isAttachmentList
        />
    );
};

CopilotBarFileUpload.propTypes = {
    files: PropTypes.array,
    isLoading: PropTypes.bool,
    maxFiles: PropTypes.number,
    onFilesChange: PropTypes.func.isRequired,
};

CopilotBarFileUpload.displayName = 'CopilotBarFileUpload';

export default CopilotBarFileUpload;
